// ── The staff rehearsal's two client flags (`EX-TST01`, `docs/29` §4.1) ─────
// Which button and which tab to draw, and nothing more: the server decides who
// may rehearse and when, and refuses everything else. The rule mirrors
// `contestStaffReads` on the backend - every staff role but `volunteer` - and
// the window: a draft or a scheduled round that has not started.

import type { ContestStaffRole, PublicContestDetail } from "../types";

type RehearsalContest = Pick<PublicContestDetail, "phase" | "viewer"> | null | undefined;

/** The owner, a moderator, an author or a tester; never a volunteer. */
export function staffReads(role: ContestStaffRole | null | undefined): boolean {
  return role != null && role !== "volunteer";
}

/** Whether to offer "Submit rehearsal": staff, signed in, before the start. */
export function canRehearseNow(contest: RehearsalContest, isAuthenticated: boolean): boolean {
  if (!contest || !isAuthenticated) return false;
  const beforeStart = contest.phase === "draft" || contest.phase === "scheduled";
  return beforeStart && staffReads(contest.viewer.staffRole);
}

/**
 * Whether to show the rehearsal record: staff at any time, and anybody who
 * moderates the round, because a moderator already reads every submission.
 */
export function canReadRehearsals(contest: RehearsalContest, isAuthenticated: boolean): boolean {
  if (!contest || !isAuthenticated) return false;
  return staffReads(contest.viewer.staffRole) || contest.viewer.canModerate;
}
